import React, {useEffect, useRef} from 'react';
import _ from 'lodash';

import K from '../k';

import Icon from './icon';
import useClickOutside from '../hooks/click-outside';

const PopupTypes = {
  PANE: 'pane',
  MODAL: 'modal',
};

const {placements} = K;

const Popup = ({type = PopupTypes.MODAL, placement = placements.RIGHT, visible, shadow, children, style, contentStyle, closable = true, closeIcon, onClose, className}) => {
  //HINT panes with center placements render as modals
  if (type === PopupTypes.PANE && placement === placements.CENTER) type = PopupTypes.MODAL;

  const isVertical = _.includes([placements.LEFT, placements.RIGHT], placement);
  const closeIconPlacement = type === PopupTypes.MODAL ? placements.RIGHT : placement === placements.RIGHT ? placements.LEFT : placements.RIGHT;
  const popup = useRef(null);

  const styles = {
    overlay: {
      ...(type === PopupTypes.MODAL ? {display: 'flex', alignItems: 'center', justifyContent: 'center'} : {}),
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      overflow: 'hidden',
      zIndex: Number.MAX_SAFE_INTEGER,
      backgroundColor: K.colors.overlay,
      ...style
    },
    modal: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: K.colors.base,
      padding: K.spacing * 2,
      ...(shadow ? K.shadow : {}),
      ...contentStyle,
    },
    pane: {
      [placement]: 0,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: K.colors.base,
      padding: K.spacing * 2,
      ...(isVertical ? {
        height: '100%',
        maxWidth: '50vw',
      } : {
        width: '100%',
        maxHeight: '50vh',
      }),
      ...(shadow ? K.shadow : {}),
      ...contentStyle,
    },
    closeIcon: {
      margin: K.spacing / 2,
      position: 'absolute',
      top: 0,
      [closeIconPlacement]: 0,
      width: '20px',
      height: '20px',
    }
  };

  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  const handleClose = () => onClose?.();
  const handleKeyUp = (event) => event.key === 'Escape' ? handleClose() : null;

  useClickOutside(popup, handleClose);

  return visible ? (
    <div {...{className}} style={styles.overlay}>
      <div style={styles[type]} ref={popup}>
        {closable && <Icon icon={closeIcon} name='close' style={styles.closeIcon} onClick={handleClose}/>}
        {children}
      </div>
    </div>
  ) : null;
};

export default Popup;